import BaseLayout from "../Layout/BaseLayout";
import { useTranslation } from "react-i18next";
//heroicon
import { Button, Divider } from "@nextui-org/react";
import { Swiper, SwiperSlide } from "swiper/react";
import { LuFactory } from "react-icons/lu";
import { MdOutlineContactPhone } from "react-icons/md";
import { useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";

export default function ContactPage() {
  const { t } = useTranslation();
  const navigate = useNavigate();

  return (
    <BaseLayout>
      <Helmet>
        <title>{t("menucontactUs")}</title>
        <meta name="description" content={t("menucontactUs")} />
      </Helmet>
      <Swiper dir="ltr" className="h-[20rem] lg:h-[35rem] ">
        <div className="text-white text-xl  lg:text-3xl absolute top-[60%] left-[50%]  lg:left-[70%] transform -translate-x-1/2 -translate-y-1/2 z-10  flex flex-col gap-3 items-center">
          {t("menucontactUs")}
          <Divider className="  h-1 bg-red-600   " />
          <div
            className={`bg-white px-5 py-2 rounded-md   flex justify-center items-center w-full whitespace-nowrap ${
              localStorage.getItem("lng") === "fa"
                ? "rtl"
                : localStorage.getItem("lng") === "en"
                ? "ltr"
                : ""
            }`}
          >
            <div
              className="text-sm text-gray-600 cursor-pointer "
              onClick={() => navigate("/")}
            >
              {t("menuHome")}
            </div>
            <span className="px-1  text-black">/</span>
            <div>
              <span className="text-[15px] font-bold text-black">
                {t("menucontactUs")}
              </span>
            </div>
          </div>
        </div>
        <SwiperSlide
          key={1}
          className="from-[#002d78]  bg-gradient-to-l to-transparent  "
        >
          <img
            dir="ltr"
            src="/Assets/Images/contact.jpg"
            className="lg:w-[50%] h-full "
            alt="1"
            style={{
              WebkitMaskImage:
                "linear-gradient(to right, black 40%, transparent 100%)",
              maskImage:
                "linear-gradient(to right, black 40%, transparent 100%)",
            }}
          />
        </SwiperSlide>
      </Swiper>
      <div className="grid md:flex justify-center gap-5 md:gap-10 mt-10 lg:mt-20 mb-10 ">
        <Button
          className="w-80 h-40 bg-white hover:bg-primary-800 hover:text-white flex flex-col text-lg"
          onClick={() =>
            navigate(`/${localStorage.getItem("lng")}/contact/head-office`)
          }
        >
          <MdOutlineContactPhone size={50} color="#3EA3DB" />
          {t("CentralOffice")}
        </Button>
        <Button
          className="w-80 h-40 bg-white hover:bg-primary-800 hover:text-white  flex flex-col text-lg"
          onClick={() =>
            navigate(`/${localStorage.getItem("lng")}/contact/factory`)
          }
        >
          <LuFactory size={50} color="#3EA3DB" />

          {t("factory")}
        </Button>
      </div>
    </BaseLayout>
  );
}
